import { API_ROUTES } from "@/constants/api";
import type { Schedule } from "@/components/Shared/ScheduleDisplay";

export type CareerClassroom = {
  classroom: string;
  initialDate: string;
  mode?: string;
  officeLocation?: string;
  schedule?: Schedule[];
  careerData?: {
    name: string;
    description?: string;
    durationMonths?: number;
  };
};

export async function findCareerClassroom(
  classroomParam: string
): Promise<CareerClassroom | null> {
  const response = await fetch(
    `${API_ROUTES.CAREER_CLASSROOMS}?classroom=${encodeURIComponent(classroomParam)}`
  );
  if (!response.ok) {
    throw new Error("Failed to fetch career classrooms");
  }
  const entry: CareerClassroom | null = await response.json();
  return entry?.classroom ? entry : null;
}
